import { Link, Table, Tbody, Text } from '@chakra-ui/react'
import type { InsuranceParamsPropertyDto } from 'BrokerTsLib/src/dtos'
import { formatPersonAddress, formatPersonFullName } from 'BrokerTsLib/src/dtos'
import { useContext } from 'react'

import {
  FormSection,
  FormSectionBody,
  FormSectionHeader,
  FormSectionTitle,
} from '../../components/FormSection'
import { useInsuranceParamsContext } from '../../layouts/Wizard'
import { meetingRecordContext } from '../../pages/carkulka/wizard/5'
import { RecapTableRow } from './Recap'
import { UserContractRecapTableRow } from '../shared/UserContractRecapTableRow'

export const ContractRecap = () => {
  const { insuranceParams: ip } = useInsuranceParamsContext()
  const { meetingRecord } = useContext(meetingRecordContext)
  const insuranceParams = ip as InsuranceParamsPropertyDto

  const ph = insuranceParams?.policyHolder?.person
  const phone = ph?.mobilePhone ?? ph?.phone
  const createdBy = insuranceParams?.generalParams?.createdBy
  const contractCreatedBy = insuranceParams?.generalParams?.contractCreatedBy

  return (
    <FormSection>
      <FormSectionHeader>
        <FormSectionTitle>Údaje o smlouvě</FormSectionTitle>
      </FormSectionHeader>

      <FormSectionBody>
        <Table variant="unstyled">
          <Tbody>
            <RecapTableRow col1="Název nabídky" col2={insuranceParams.generalParams.name} />
            <RecapTableRow col1="Pojistník" col2={formatPersonFullName(ph)} />
            <RecapTableRow col1="Adresa" col2={formatPersonAddress(ph.address)} />
            <RecapTableRow
              col1="Kontakty"
              col2={
                <>
                  <Link href={`tel:${phone}`}>{phone}</Link>,&nbsp;
                  <Link href={`mailto:${ph.email}`}>{ph.email}</Link>
                </>
              }
            />
          </Tbody>
        </Table>

        <Table variant="unstyled">
          <Tbody>
            <RecapTableRow
              col1="Zpracovatel nabídky"
              col2={createdBy ? <UserContractRecapTableRow user={createdBy} date={insuranceParams.generalParams.created!} /> : null}
            />

            {contractCreatedBy &&
              <RecapTableRow
                col1="Sjednatel smlouvy"
                col2={<UserContractRecapTableRow user={contractCreatedBy} date={insuranceParams.generalParams.contractCreatedDate!} />}
              />
            }

            {meetingRecord?.brokerNumbers &&
              <RecapTableRow
                col1="Získatelské číslo"
                col2={meetingRecord.brokerNumbers.map(bn => <Text key={bn.acquisitionNumber}>{bn.acquisitionNumber}</Text>)}
              />
            }
          </Tbody>
        </Table>
      </FormSectionBody>
    </FormSection>
  )
}
